import EventsService from "./events";

export default { 
    ...EventsService
 };